<div class="bg-red">
  <div class="px-16 py-4">
    <p class="small text-right text-white">
      <strong>Registered Attendees:</strong> {{ attendeeCount}}
    </p>
  </div>
</div>
